import { AtlassianIcon, ConfluenceIcon, JiraIcon, JiraServiceManagementIcon } from '@atlaskit/logo';

import { type RovoLogo, RovoLogoFromLogo } from './icons';
import { type ProductKeys as AllProductKeys, ProductKeys } from './products';

export interface ProductCategoryConfig {
	productCategory: ProductCategoryKeys;
	displayName: React.ReactNode;
	Icon: RovoLogo;
	products: AllProductKeys[];
}

export const ProductCategoryKey: {
	readonly Confluence: 'confluence';
	readonly Atlas: 'atlas';
	readonly Jira: 'jira';
	readonly JiraServiceManagement: 'jira-servicedesk';
} = {
	Confluence: 'confluence',
	Atlas: 'atlas',
	Jira: 'jira',
	JiraServiceManagement: 'jira-servicedesk',
} as const;

export type ProductCategoryKeys = (typeof ProductCategoryKey)[keyof typeof ProductCategoryKey];

export const productCategories: Record<ProductCategoryKeys, ProductCategoryConfig> = {
	[ProductCategoryKey.Confluence]: {
		productCategory: ProductCategoryKey.Confluence,
		displayName: 'Confluence',
		Icon: RovoLogoFromLogo(ConfluenceIcon, 'Confluence'),
		products: [ProductKeys.Confluence, ProductKeys.ConfluenceDC],
	},
	[ProductCategoryKey.Atlas]: {
		productCategory: ProductCategoryKey.Atlas,
		displayName: 'Atlas',
		Icon: RovoLogoFromLogo(AtlassianIcon, 'Atlas'),
		products: [ProductKeys.Atlas, ProductKeys.AtlassianWebCrawler],
	},
	[ProductCategoryKey.Jira]: {
		productCategory: ProductCategoryKey.Jira,
		displayName: 'Jira',
		Icon: RovoLogoFromLogo(JiraIcon, 'Jira'),
		products: [ProductKeys.Jira, ProductKeys.JiraDC],
	},
	[ProductCategoryKey.JiraServiceManagement]: {
		productCategory: ProductCategoryKey.JiraServiceManagement,
		displayName: 'Jira Service Management',
		Icon: RovoLogoFromLogo(JiraServiceManagementIcon, 'Jira Service Management'),
		products: [ProductKeys.JiraServiceManagement, ProductKeys.JsmDC],
	},
};

export const getCategoryForProduct: (
	productKey: AllProductKeys,
) => ProductCategoryConfig | undefined = (productKey: AllProductKeys) => {
	return Object.values(productCategories).find(
		(categoryConfig) => categoryConfig.productCategory === productKey,
	);
};
